import { useEffect, useRef } from 'react';
import { useFormWatch } from '../../helpers/formManager';
import { useClientByPhoneQuery } from './api/useClientByPhoneQuery';
import { PHONE_LENGTH, fieldNames, nameFieldNames } from './constants';

const filledFields = [...nameFieldNames, fieldNames.email];

const getClientValues = (client) => {
  const [surName, firstName, patrName] = (client.fio || '').trim().split(/\s+/);
  const fromFio = { surName, firstName, patrName };

  return filledFields.reduce((acc, name) => {
    acc[name] = client[name] || fromFio[name] || '';
    return acc;
  }, {});
};

export const useExistingClient = ({ control, setValue, excludeId }) => {
  const phone = useFormWatch({ control, name: fieldNames.phone });
  const isFullPhone = phone?.length === PHONE_LENGTH;

  const { data, isFetching } = useClientByPhoneQuery(
    isFullPhone ? phone : undefined
  );

  const foundClient =
    isFullPhone && data && data !== 'Error' && data.id ? data : undefined;

  const existingClient =
    foundClient && foundClient.id !== excludeId ? foundClient : undefined;

  const wasFilledRef = useRef(false);

  useEffect(() => {
    if (existingClient) {
      const values = getClientValues(existingClient);
      filledFields.forEach((name) =>
        setValue(name, values[name], { shouldValidate: true })
      );
      wasFilledRef.current = true;
      return;
    }

    if (wasFilledRef.current) {
      filledFields.forEach((name) => setValue(name, ''));
      wasFilledRef.current = false;
    }
  }, [existingClient, setValue]);

  return { existingClient, isSearching: isFullPhone && isFetching };
};
